module.exports = __webpack_public_path__ + "img/photo-0039.cd4fb942.jpg";